export interface SocketMessageProps {
    shop: string;
    type: SOCKET_MESSAGE_TYPES;
    payload?: {
        fromPhoneNumber?: string;
        conversationId?: number;
        externalId?: string;
        nextStatus?: string;
        content?: string;
        time?: Date;
    }
}

export enum SOCKET_MESSAGE_TYPES {
    PING = 'ping',
    PONG = 'pong',
    NEW_MESSAGE = 'new-message',
    STATUS_UPDATE = 'status-update',
}